export default "__VITE_ASSET__BNcuLkYK__"